import * as Phaser from "phaser";
import { Database } from "$/providers/supabase/database.types.ts";

export class StorageGlobalPlugin extends Phaser.Plugins.BasePlugin {
  private registry!: Phaser.Data.DataManager;

  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
    this.registry = pluginManager.game.registry;
  }

  public pet = () => {
    return this.registry.get(
      "pet",
    ) as Database["public"]["Tables"]["pet"]["Row"] & {
      poop: number;
      food: number;
    };
  };

  public items = () => {
    return this.registry.get(
      "items",
    ) as Database["public"]["Tables"]["item"]["Row"][];
  };

  public user = () => {
    return this.registry.get(
      "user",
    ) as Database["public"]["Tables"]["tg_user"]["Row"];
  };
}
